import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { z } from 'zod';
import { DraftDocumentRecordSchema } from '../base/draftDocument.js';
import { GuidedDocumentTypeSchema } from '../base/guidedDocument.js';
export const GetGuidedDocumentPathSchema = z.object({
    entityId: ClaimV2CornSchema,
    guidedDocumentType: GuidedDocumentTypeSchema,
});
export const GetGuidedDocumentResponseSchema = z.object({
    draftDocument: DraftDocumentRecordSchema,
    documentUrl: z.string().optional(),
});
export const GetGuidedDocumentRequestSchema = GetGuidedDocumentPathSchema;
export const GetGuidedDocumentApiSchema = {
    params: GetGuidedDocumentPathSchema,
    response: GetGuidedDocumentResponseSchema,
};
